import React, { useEffect, useState, useRef, useLayoutEffect } from "react"
import addLeadingZeros from "../../../functions/addLeadingZero"
import "./styles.scss"
import Reactmarkdown from "react-markdown"

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

const Accordion = ({
  tabs,
  className,
  isNumeric = false,
  defaultActiveTab = null,
  openFirstMobile = false,
  isDesktop = null,
}) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab)
  const [previosActiveTab, setPreviousActiveTab] = useState("")
  const parentRef = useRef(null)

  const closeTabs = () => {
    const items = parentRef.current.querySelectorAll(".accordion__body")
    setPreviousActiveTab(null)

    items.forEach(item => {
      gsap.to(item, {
        duration: 0.4,
        maxHeight: 0,
        ease: "power2.out",
      })
    })
  }

  const handleTab = () => {
    ScrollTrigger.refresh(true)

    closeTabs()

    if (previosActiveTab === activeTab) return

    const body = parentRef.current.querySelector(
      `.accordion__item:nth-child(${activeTab + 1}) .accordion__body`
    )

    gsap.to(body, {
      duration: 0.4,
      maxHeight: body.scrollHeight,
      ease: "power2.out",
    })

    setPreviousActiveTab(activeTab)
  }

  useEffect(() => {
    if (defaultActiveTab) return

    setActiveTab(openFirstMobile && isDesktop === false ? 0 : null)
  }, [isDesktop])

  useEffect(() => {
    if (activeTab === null) return

    handleTab()
  }, [activeTab])

  return (
    <div className={["accordion", className].join(" ")} ref={parentRef}>
      {tabs.map((tab, i) => {
        return (
          <div
            key={i}
            onClick={() => handleTab(i)}
            className={`accordion__item ${i !== activeTab ? "" : "--active"}`}
          >
            <div className="accordion__head" onClick={() => setActiveTab(i)}>
              <div className="accordion__headNumber">
                {isNumeric ? addLeadingZeros(i + 1, 2) : ""}
              </div>
              <h5 className="accordion__headTitle">{tab.name || tab.title}</h5>
            </div>
            <div className="accordion__body">
              <div className="accordion__bodyRow">
                {tab?.leftText && (
                  <Reactmarkdown
                    className="accordion__text accordion__text--left"
                    source={tab.leftText}
                  />
                )}
                {tab?.rightText && (
                  <Reactmarkdown
                    className="accordion__text accordion__text--right"
                    source={tab.rightText}
                  />
                )}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Accordion
